import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../wayfinder'
/**
* @see \Spatie\MediaLibraryPro\Http\Controllers\MediaLibraryStylesController::__invoke
* @see vendor/spatie/laravel-medialibrary-pro/src/Http/Controllers/MediaLibraryStylesController.php:9
* @route '/media-library-pro/styles.css'
*/
export const mediaLibraryStyles = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: mediaLibraryStyles.url(options),
    method: 'get',
})

mediaLibraryStyles.definition = {
    methods: ["get","head"],
    url: '/media-library-pro/styles.css',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Spatie\MediaLibraryPro\Http\Controllers\MediaLibraryStylesController::__invoke
* @see vendor/spatie/laravel-medialibrary-pro/src/Http/Controllers/MediaLibraryStylesController.php:9
* @route '/media-library-pro/styles.css'
*/
mediaLibraryStyles.url = (options?: RouteQueryOptions) => {
    return mediaLibraryStyles.definition.url + queryParams(options)
}

/**
* @see \Spatie\MediaLibraryPro\Http\Controllers\MediaLibraryStylesController::__invoke
* @see vendor/spatie/laravel-medialibrary-pro/src/Http/Controllers/MediaLibraryStylesController.php:9
* @route '/media-library-pro/styles.css'
*/
mediaLibraryStyles.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: mediaLibraryStyles.url(options),
    method: 'get',
})

/**
* @see \Spatie\MediaLibraryPro\Http\Controllers\MediaLibraryStylesController::__invoke
* @see vendor/spatie/laravel-medialibrary-pro/src/Http/Controllers/MediaLibraryStylesController.php:9
* @route '/media-library-pro/styles.css'
*/
mediaLibraryStyles.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: mediaLibraryStyles.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\FontFamilyController::__invoke
* @see app/Http/Controllers/FontFamilyController.php:14
* @route '/font-families/{fontFamily}'
*/
export const fontFamilies = (args: { fontFamily: string | { id: string } } | [fontFamily: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: fontFamilies.url(args, options),
    method: 'get',
})

fontFamilies.definition = {
    methods: ["get","head"],
    url: '/font-families/{fontFamily}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FontFamilyController::__invoke
* @see app/Http/Controllers/FontFamilyController.php:14
* @route '/font-families/{fontFamily}'
*/
fontFamilies.url = (args: { fontFamily: string | { id: string } } | [fontFamily: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { fontFamily: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { fontFamily: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            fontFamily: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        fontFamily: typeof args.fontFamily === 'object'
        ? args.fontFamily.id
        : args.fontFamily,
    }

    return fontFamilies.definition.url
            .replace('{fontFamily}', parsedArgs.fontFamily.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FontFamilyController::__invoke
* @see app/Http/Controllers/FontFamilyController.php:14
* @route '/font-families/{fontFamily}'
*/
fontFamilies.get = (args: { fontFamily: string | { id: string } } | [fontFamily: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: fontFamilies.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FontFamilyController::__invoke
* @see app/Http/Controllers/FontFamilyController.php:14
* @route '/font-families/{fontFamily}'
*/
fontFamilies.head = (args: { fontFamily: string | { id: string } } | [fontFamily: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: fontFamilies.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\DashboardController::__invoke
* @see app/Http/Controllers/DashboardController.php:21
* @route '/dashboard'
*/
export const dashboard = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

dashboard.definition = {
    methods: ["get","head"],
    url: '/dashboard',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\DashboardController::__invoke
* @see app/Http/Controllers/DashboardController.php:21
* @route '/dashboard'
*/
dashboard.url = (options?: RouteQueryOptions) => {
    return dashboard.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\DashboardController::__invoke
* @see app/Http/Controllers/DashboardController.php:21
* @route '/dashboard'
*/
dashboard.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\DashboardController::__invoke
* @see app/Http/Controllers/DashboardController.php:21
* @route '/dashboard'
*/
dashboard.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: dashboard.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Settings\SettingsController::__invoke
* @see app/Http/Controllers/Settings/SettingsController.php:17
* @route '/settings'
*/
export const settings = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: settings.url(options),
    method: 'get',
})

settings.definition = {
    methods: ["get","head"],
    url: '/settings',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Settings\SettingsController::__invoke
* @see app/Http/Controllers/Settings/SettingsController.php:17
* @route '/settings'
*/
settings.url = (options?: RouteQueryOptions) => {
    return settings.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\SettingsController::__invoke
* @see app/Http/Controllers/Settings/SettingsController.php:17
* @route '/settings'
*/
settings.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: settings.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Settings\SettingsController::__invoke
* @see app/Http/Controllers/Settings/SettingsController.php:17
* @route '/settings'
*/
settings.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: settings.url(options),
    method: 'head',
})

/**
* @see \Spatie\MediaLibraryPro\Http\Controllers\MediaLibraryUploadController::__invoke
* @see vendor/spatie/laravel-medialibrary-pro/src/Http/Controllers/MediaLibraryUploadController.php:13
* @route '/media-library-pro/uploads'
*/
export const mediaLibraryUploads = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: mediaLibraryUploads.url(options),
    method: 'post',
})

mediaLibraryUploads.definition = {
    methods: ["post"],
    url: '/media-library-pro/uploads',
} satisfies RouteDefinition<["post"]>

/**
* @see \Spatie\MediaLibraryPro\Http\Controllers\MediaLibraryUploadController::__invoke
* @see vendor/spatie/laravel-medialibrary-pro/src/Http/Controllers/MediaLibraryUploadController.php:13
* @route '/media-library-pro/uploads'
*/
mediaLibraryUploads.url = (options?: RouteQueryOptions) => {
    return mediaLibraryUploads.definition.url + queryParams(options)
}

/**
* @see \Spatie\MediaLibraryPro\Http\Controllers\MediaLibraryUploadController::__invoke
* @see vendor/spatie/laravel-medialibrary-pro/src/Http/Controllers/MediaLibraryUploadController.php:13
* @route '/media-library-pro/uploads'
*/
mediaLibraryUploads.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: mediaLibraryUploads.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\RequestAccessController::__invoke
* @see app/Http/Controllers/RequestAccessController.php:18
* @route '/request-access/{productKey}'
*/
export const requestAccess = (args: { productKey: string | number } | [productKey: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: requestAccess.url(args, options),
    method: 'post',
})

requestAccess.definition = {
    methods: ["post"],
    url: '/request-access/{productKey}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\RequestAccessController::__invoke
* @see app/Http/Controllers/RequestAccessController.php:18
* @route '/request-access/{productKey}'
*/
requestAccess.url = (args: { productKey: string | number } | [productKey: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { productKey: args }
    }

    if (Array.isArray(args)) {
        args = {
            productKey: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        productKey: args.productKey,
    }

    return requestAccess.definition.url
            .replace('{productKey}', parsedArgs.productKey.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\RequestAccessController::__invoke
* @see app/Http/Controllers/RequestAccessController.php:18
* @route '/request-access/{productKey}'
*/
requestAccess.post = (args: { productKey: string | number } | [productKey: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: requestAccess.url(args, options),
    method: 'post',
})

/**
* @see routes/web.php:307
* @route '/boot-error'
*/
export const bootError = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bootError.url(options),
    method: 'post',
})

bootError.definition = {
    methods: ["post"],
    url: '/boot-error',
} satisfies RouteDefinition<["post"]>

/**
* @see routes/web.php:307
* @route '/boot-error'
*/
bootError.url = (options?: RouteQueryOptions) => {
    return bootError.definition.url + queryParams(options)
}

/**
* @see routes/web.php:307
* @route '/boot-error'
*/
bootError.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bootError.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:30
* @route '/login'
*/
export const login = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

login.definition = {
    methods: ["get","head"],
    url: '/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:30
* @route '/login'
*/
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:30
* @route '/login'
*/
login.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:30
* @route '/login'
*/
login.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: login.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:69
* @route '/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: logout.url(options),
    method: 'get',
})

logout.definition = {
    methods: ["get","post","head"],
    url: '/logout',
} satisfies RouteDefinition<["get","post","head"]>

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:69
* @route '/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:69
* @route '/logout'
*/
logout.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: logout.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:69
* @route '/logout'
*/
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:69
* @route '/logout'
*/
logout.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: logout.url(options),
    method: 'head',
})

